var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuratura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9167 25.9V16.7666L6.91667 12.1333V21.2666L14.9167 25.9ZM17.5833 25.9L25.5833 21.2666V12.1333L17.5833 16.7666V25.9ZM16.25 14.4666L24.15 9.89996L16.25 5.33329L8.35 9.89996L16.25 14.4666ZM5.58333 23.6C5.16111 23.3555 4.83333 23.0333 4.6 22.6333C4.36667 22.2333 4.25 21.7888 4.25 21.3V10.7C4.25 10.2111 4.36667 9.76663 4.6 9.36663C4.83333 8.96663 5.16111 8.6444 5.58333 8.39996L14.9167 3.03329C15.3389 2.78885 15.7833 2.66663 16.25 2.66663C16.7167 2.66663 17.1611 2.78885 17.5833 3.03329L26.9167 8.39996C27.3389 8.6444 27.6667 8.96663 27.9 9.36663C28.1333 9.76663 28.25 10.2111 28.25 10.7V21.3C28.25 21.7888 28.1333 22.2333 27.9 22.6333C27.6667 23.0333 27.3389 23.3555 26.9167 23.6L17.5833 28.9666C17.1611 29.2111 16.7167 29.3333 16.25 29.3333C15.7833 29.3333 15.3389 29.2111 14.9167 28.9666L5.58333 23.6Z",
    fill: "#D3135A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuratura);
export default __webpack_public_path__ + "static/media/muratura.a57b418e51e91167676b93990ec978a4.svg";
export { ForwardRef as ReactComponent };